<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="person-badge" class="mr-2"></b-icon>Xodimlar oylik hisoboti</h2>
        </div>
        <button class="rp-btn rp-btn-secondary" @click="exportCsv" :disabled="loading || items.length === 0">
          <b-icon icon="file-earmark-excel"></b-icon> Excel
        </button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter"><label>&nbsp;</label><button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button></div>
      </div>

      <div class="rp-summary rp-summary-4">
        <div class="rp-card rp-c-1"><div class="rp-card-label">XODIMLAR</div><div class="rp-card-value">{{ items.length }}</div></div>
        <div class="rp-card rp-c-2"><div class="rp-card-label">JAMI HISOBLANDI</div><div class="rp-card-value rp-green">{{ fmt(totals.earned) }}</div></div>
        <div class="rp-card rp-c-3"><div class="rp-card-label">JAMI TO'LANDI</div><div class="rp-card-value rp-red">{{ fmt(totals.paid) }}</div></div>
        <div class="rp-card rp-c-4"><div class="rp-card-label">JAMI BALANS</div><div class="rp-card-value" :class="totals.end_balance >= 0 ? 'rp-green' : 'rp-red'">{{ fmt(totals.end_balance) }}</div></div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title"><b-icon icon="list-ul"></b-icon> Xodimlar ro'yxati</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>#</th><th>F.I.O</th><th>Lavozim</th>
                <th class="t-right">Kunlik fiksa</th><th class="t-right">Bonus %</th>
                <th class="t-right">Boshlang'ich</th>
                <th class="t-right">Hisoblandi</th>
                <th class="t-right">To'landi</th>
                <th class="t-right">Balans</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in items" :key="r.staff_id">
                <td><span class="rp-num">{{ i + 1 }}</span></td>
                <td class="rp-strong">{{ r.staff_name }}</td>
                <td class="rp-muted">{{ r.position || '—' }}</td>
                <td class="t-right">{{ fmt(r.fixed_salary) }}</td>
                <td class="t-right"><span class="rp-badge rp-badge-purple">{{ r.bonus_percent }}%</span></td>
                <td class="t-right">{{ fmt(r.begin_balance) }}</td>
                <td class="t-right rp-green">{{ fmt(r.earned) }}</td>
                <td class="t-right rp-red">{{ fmt(r.paid) }}</td>
                <td class="t-right rp-strong" :class="r.end_balance > 0 ? 'rp-green' : (r.end_balance < 0 ? 'rp-red' : '')">{{ fmt(r.end_balance) }}</td>
              </tr>
              <tr v-if="!loading && items.length === 0"><td colspan="9" class="rp-empty">Xodim topilmadi</td></tr>
            </tbody>
            <tfoot v-if="items.length > 0">
              <tr>
                <th colspan="6" class="t-right">JAMI:</th>
                <th class="t-right">{{ fmt(totals.earned) }}</th>
                <th class="t-right">{{ fmt(totals.paid) }}</th>
                <th class="t-right">{{ fmt(totals.end_balance) }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
export default {
  data() {
    const today = new Date(); const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first), date2: this.ds(today),
      sklad_id: null, skladList: [], items: [],
      totals: { earned: 0, paid: 0, end_balance: 0 }, loading: false,
    };
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/staff-salary/', {
          datetime1: this.toUnix(this.date1), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        this.items = r.data.items || [];
        this.totals = r.data.totals || this.totals;
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    exportCsv() {
      const h = ['Xodim', 'Lavozim', 'Fiksa', 'Bonus%', 'Boshlangich', 'Hisoblandi', 'Tolandi', 'Balans'];
      const rows = this.items.map(r => [r.staff_name, r.position, r.fixed_salary, r.bonus_percent, r.begin_balance, r.earned, r.paid, r.end_balance]);
      const csv = [h, ...rows].map(x => x.map(c => `"${String(c||'').replace(/"/g,'""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿"+csv], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `xodimlar_oylik_${this.date1}_${this.date2}.csv`; a.click();
    }
  }
};
</script>
